export const largeBreakpoint = 1068;
export const mediumBreakpoint = 734;
